module.exports = __webpack_public_path__ + "img/Calender-1.fa7d3d79.svg";